<template>
  <memlist-modal size="lg" ref="person-modal">

    <m-row>
      <m-col lg="6">
        <memlist-text-input
          id="person_id"
          name="person_id"
          title="ID"
          layout="vertical"
          v-model="person_id"
          :disabled="true"
        />
      </m-col>
      <m-col lg="6">
      
      </m-col>
    </m-row>
    
    <m-row>
      <m-col lg="6">
        <memlist-text-input
          id="person_name"
          name="person_name"
          :title="$t('MEMBER.FIRSTNAME')"
          layout="vertical"
          v-model="local_item.firstname"
        />
      </m-col>
      <m-col lg="6">
        <memlist-text-input
          id="person_lastname"
          name="person_lastname"
          :title="$t('MEMBER.LASTNAME')"
          layout="vertical"
          v-model="local_item.lastname"
        />
      </m-col>
    </m-row>

    <m-row>
      <m-col lg="6">
        <memlist-text-input
          id="person_phone"
          name="person_phone"
          :title="$t('MEMBER.PHONE')"
          layout="vertical"
          v-model="local_item.phone"
        />
      </m-col>
      <m-col lg="6">
        <memlist-text-input
          id="person_email"
          name="person_email"
          :title="$t('MEMBER.EMAIL')"
          layout="vertical"
          v-model="local_item.email"
        />
      </m-col>
    </m-row>

    <m-row>
      <m-col lg="6">
        <memlist-text-input
          id="person_personnr"
          name="person_personnr"
          :title="$t('MEMBER.PERSONNR')"
          layout="vertical"
          v-model="local_item.personnr"
        />
      </m-col>
      <m-col lg="6">
        
      </m-col>
    </m-row>

    <m-row>
      <m-col lg="6">
        <memlist-text-input
          id="person_cname"
          name="person_cname"
          :title="$t('MEMBER.CNAME')"
          layout="vertical"
          v-model="local_item.cname"
        />
      </m-col>
      <m-col lg="6">
        <memlist-text-input
          id="person_org_number"
          name="person_org_number"
          :title="$t('MEMBER.ORG_NUMBER')"
          layout="vertical"
          v-model="local_item.org_number"
        />
      </m-col>
    </m-row>

    <m-row>
      <m-col lg="6">
        <memlist-text-input
          id="person_address"
          name="person_address"
          :title="$t('MEMBER.ADDRESS')"
          layout="vertical"
          v-model="local_item.address"
        />
      </m-col>
      <m-col lg="6">
        <memlist-text-input
          id="person_co"
          name="person_co"
          :title="$t('MEMBER.CO')"
          layout="vertical"
          v-model="local_item.co"
        />
      </m-col>
    </m-row>

    <m-row>
      <m-col lg="6">
        <memlist-text-input
          id="person_post"
          name="person_post"
          :title="$t('MEMBER.POST')"
          layout="vertical"
          v-model="local_item.post"
        />
      </m-col>
      <m-col lg="6">
        <memlist-text-input
          id="person_zipcode"
          name="person_zipcode"
          :title="$t('MEMBER.ZIPCODE')"
          layout="vertical"
          v-model="local_item.zipcode"
        />
      </m-col>
    </m-row>

    <m-row class="mt-4">
      <m-col lg="12">

        <RightModalSaveAndCloseButtons
          :text="$t('COMMON.SAVE')"
          :spin="true"
          @click="on_submit"
          @close="close"
          ref="saveButton"
        />
      </m-col>
    </m-row>

  </memlist-modal>
</template>

<script>
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';


export default {
  name: 'PersonEditorModal',
  props: ['person_id'],
  mixins: [ toasts ],
  
  emits: ['created', 'updated', 'deleted'],
  data() {
    return {
      local_person_id: null,
      local_item: {}
    };
  },
  components: { 

  },
  watch: {
    person_id: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      async handler(val) {
        
        this.local_person_id = val;

        if (this.local_person_id) {
          const p = await this.fetch_person(this.local_person_id);

          if (p) {
            this.local_item = p;
          }
          else {
            this.local_item = {};
          }
        }
        else {
          this.local_item = {};
        }
      },
      immediate: true
    },

  },
  async mounted() {
    
  },

  methods: {
    
    on_submit() {
      if (this.local_item.person_id) {
        this.put_person(this.local_item.person_id, this.local_item);
      }
      else {
        this.post_person(this.local_item);
      }

      this.$refs['saveButton'].stop();
    },


    show() {
      this.$refs['person-modal'].show();
    },

    close() {
      this.$refs['person-modal'].hide();
    },

    async post_person(data) {
      try {
        const res = await axios.post(`/person`, data);

        if (res.status === 200) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('COMMON.CREATED'));

          this.$emit('created', res.data);
          return res.data;
        }
      }
      catch (err) {
        console.error('fetch_person error', err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_CREATE'));

      return null;
    },

    async put_person(id, data) {
      try {
        const res = await axios.put(`/person/${id}`, data);

        if (res.status === 200) {
          this.toastr('success', this.$t('COMMON.OK'), this.$t('COMMON.UPDATED'));

          this.$emit('updated', res.data);

          return res.data;
        }
      }
      catch (err) {
        console.error('fetch_person error', err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_UPDATE'));

      return null;
    },

    async fetch_person(id) {
      try {
        const res = await axios.get(`/person/${id}`);

        if (res.status === 200) {
          return res.data;
        }
      }
      catch (err) {
        console.error('fetch_person error', err);
      }

      return null;
    },

  },
};
</script>
